import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { IconButton, Typography } from "@mui/material";
import { useState } from "react";
import "./Carousel.css"; // Le fichier CSS pour le style

const images = [
  "abf2024.jpeg",
  "abf2025.jpg",
  "abf2024.jpeg",
  "abf2025.jpg",
  "abf2024.jpeg",
  "abf2025.jpg",
  // Ajoute d'autres images si nécessaire
];

const CarouselAbf = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <>
      <div>
        <Typography variant="h4" align="center" marginBottom={2}>
          Depuis 2021
        </Typography>
      </div>
      <div className="carousel-container">
        <IconButton onClick={prevImage} className="carousel-arrow left">
          <ArrowBack />
        </IconButton>

        <div className="carousel-images">
          {images.slice(currentIndex, currentIndex + 4).map((image, index) => (
            <div className="carousel-item" key={index}>
              <img src={image} alt={`carousel-img-${index}`} />
            </div>
          ))}
        </div>

        <IconButton onClick={nextImage} className="carousel-arrow right">
          <ArrowForward />
        </IconButton>
      </div>
    </>
  );
};

export default CarouselAbf;
